module.exports = __webpack_public_path__ + "LatoLatin-Semibold.b683c54b2bc1bf989c5f.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Semibold.eot
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Semibold.eot
// module chunks = styles